import { useDispatch, useSelector } from "react-redux";
import LeftArrowIcon from "../../../assets/arrow-left.svg?react";

import "./SidePanel.css";
import { StoreState } from "../../../store/rootReducer";
import { setLeftPanelOpen, setRightPanelOpen } from "../../../store/appSlice";

interface SidePanelProps {
    side: "left" | "right"
    panelClass?: string;
    contentClass?: string;
    children?: React.ReactNode;
    collapseButtonHidden?: boolean;
}

const SidePanel: React.FC<SidePanelProps> = ({ panelClass, side, children, contentClass, collapseButtonHidden }) => {
    const dispatch = useDispatch();
    const isOpen = useSelector((state: StoreState) => state.app[`${side}PanelOpen`]);

    const togglePanel = () => {
        if (side === "left") {
            dispatch(setLeftPanelOpen(!isOpen));
        } else if (side === "right") {
            dispatch(setRightPanelOpen(!isOpen));
        }
    }

    return (
        <div className={`side-panel ${panelClass ?? ''} ${isOpen ? 'open' : 'closed'} ${side}`}
        >
            {!collapseButtonHidden &&
                <button className={`side-panel-collapsible-button ${side}`} onClick={togglePanel}>
                    <LeftArrowIcon />
                </button>
            }
            <div
                className={`side-panel-content ${contentClass ?? ''} `}
            >
                {children}
            </div>
        </div>
    )
}




export default SidePanel;
